export default {
      id: "ic_person-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ic_person",
      toString: function () {
        return this.url;
      }
    }